import React from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter } from 'react-router-dom';

import { ThemeProvider } from '@mui/material';
import { theme } from 'broentech';
import { Provider } from 'react-redux';
import { AuthProvider } from 'oidc-react';

import App from 'App/App';
import reportWebVitals from './reportWebVitals';
import { getBasePath } from 'setup/getBasePath';
import { store } from 'store';
import { oidcConfig } from 'auth/oidc';

import './index.scss';
import { LastRouteProvider } from 'RoutePreserver/lastRouteProvider';

(async function run() {
  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  );

  root.render(
    <AuthProvider {...oidcConfig}>
      <React.StrictMode>
        <HashRouter basename={getBasePath()}>
          <ThemeProvider theme={theme}>
            <Provider store={store}>
              <LastRouteProvider>
                <App />
              </LastRouteProvider>
            </Provider>
          </ThemeProvider>
        </HashRouter>
      </React.StrictMode>
    </AuthProvider>
  );

  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  reportWebVitals();
})();
